/** Compact "2m" / "3h" / "5d" / "2w" formatter. Returns "now" when < 1 minute. */
export function formatRelativeTime(ts: number | null): string {
  if (!ts) return '';
  const diffMs = Date.now() - ts;
  if (diffMs < 60_000) return 'now';
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  const weeks = Math.floor(days / 7);
  return `${weeks}w`;
}
